export default __webpack_public_path__ + "static/icon-api-16ee909c7e6364866a0163a2da93e76c.svg";